require('./src/styles/index.css')
